import { render, staticRenderFns } from "./index.vue?vue&type=template&id=d281f21a&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=d281f21a&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d281f21a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/work/jenkins/workspace/pre预发布-anjun-express-web-management/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d281f21a')) {
      api.createRecord('d281f21a', component.options)
    } else {
      api.reload('d281f21a', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=d281f21a&scoped=true", function () {
      api.rerender('d281f21a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/customStatusBar/index.vue"
export default component.exports